import { styled } from "@mui/material"

import { TextField as DefaultTextField } from "@cirrus/ui-kit-ts"

export const TextField = styled(DefaultTextField)({
	"& .MuiFormHelperText-root": {
		padding: "4px 16px",
		fontSize: "12px",
		fontWeight: 400,
		lineHeight: "16px",
		letterSpacing: 0,
	},
	"& .notranslate": {
		display: "none"
	},
	"& .MuiFilledInput-root .MuiFilledInput-input": {
		fontSize: "1.6rem",
	},
})

export const TextFieldWithAbsoluteHelperText = styled(TextField)({
	// TODO: Apply positioning on the root component level (?)
	"& .MuiFormHelperText-root": {
		position: "absolute",
		top: "40px",
	}
})
